<div class="step-layout !mx-auto !flex !w-full !flex-col !gap-8">
    <header class="!flex !flex-col !gap-2">
        <p class="!mb-0 !text-xs !font-bold !uppercase !tracking-[0.08em] !text-primary">Richiesta inviata</p>
        <h2 class="!mb-0 !text-[clamp(1.75rem,3vw,2.25rem)] !font-extrabold !leading-tight !text-strong">
            <span class="gradient-text">Congratulazioni</span>
        </h2>
        <p class="!mb-0 !max-w-xl !text-base !leading-relaxed !text-subtle">
            Abbiamo ricevuto la tua registrazione. Il pagamento verrà addebitato solo se la richiesta sarà approvata.
        </p>
    </header>

    <section class="!overflow-visible !rounded-2xl !border !border-solid !border-border !bg-white !p-6 md:!p-8"
             aria-labelledby="congratulations-card-title">
        <div class="!mb-6 !flex !flex-col !items-center !gap-4 !border-b !border-solid !border-slate-100 !pb-6 !text-center">
            <span class="!inline-flex !h-16 !w-16 !items-center !justify-center !rounded-full !bg-emerald-50 !text-3xl !text-emerald-600"
                  aria-hidden="true">
                <i class="bi bi-check-lg"></i>
            </span>
            <div>
                <h3 id="congratulations-card-title" class="!mb-1 !text-base !font-bold !text-strong">
                    Attivazione in attesa di approvazione
                </h3>
                <p class="!mb-0 !text-sm !leading-snug !text-subtle">
                    Riceverai una mail di conferma non appena i dati saranno verificati.
                    Nel frattempo puoi accedere con le tue credenziali.
                </p>
            </div>
            <p class="!mb-0 !inline-flex !items-center !gap-2 !rounded-full !bg-amber-50 !px-3 !py-1.5 !text-sm !font-bold !text-amber-800">
                <i class="bi bi-hourglass-split !text-amber-600" aria-hidden="true"></i>
                In attesa di verifica
            </p>
        </div>

        <ul class="!m-0 !flex !list-none !flex-col !gap-4 !p-0">
            <li class="!m-0 !flex !items-start !gap-3">
                <span class="!mt-0.5 !inline-flex !h-9 !w-9 !shrink-0 !items-center !justify-center !rounded-xl !bg-slate-100 !text-primary"
                      aria-hidden="true">
                    <i class="bi bi-envelope-check"></i>
                </span>
                <div class="!min-w-0">
                    <p class="!mb-0.5 !text-sm !font-bold !text-strong">Conferma via email</p>
                    <p class="!mb-0 !text-sm !leading-snug !text-subtle">
                        Ti avviseremo quando l'account della società sarà attivo.
                    </p>
                </div>
            </li>
            <li class="!m-0 !flex !items-start !gap-3">
                <span class="!mt-0.5 !inline-flex !h-9 !w-9 !shrink-0 !items-center !justify-center !rounded-xl !bg-slate-100 !text-primary"
                      aria-hidden="true">
                    <i class="bi bi-box-arrow-in-right"></i>
                </span>
                <div class="!min-w-0">
                    <p class="!mb-0.5 !text-sm !font-bold !text-strong">Accesso già disponibile</p>
                    <p class="!mb-0 !text-sm !leading-snug !text-subtle">
                        Puoi entrare con email e password scelte in registrazione.
                    </p>
                </div>
            </li>
            <li class="!m-0 !flex !items-start !gap-3">
                <span class="!mt-0.5 !inline-flex !h-9 !w-9 !shrink-0 !items-center !justify-center !rounded-xl !bg-slate-100 !text-primary"
                      aria-hidden="true">
                    <i class="bi bi-credit-card"></i>
                </span>
                <div class="!min-w-0">
                    <p class="!mb-0.5 !text-sm !font-bold !text-strong">Nessun addebito ora</p>
                    <p class="!mb-0 !text-sm !leading-snug !text-subtle">
                        Il piano viene addebitato solo dopo l'approvazione della registrazione.
                    </p>
                </div>
            </li>
        </ul>
    </section>

    <div class="step-actions">
        <button type="button" class="btn-procedi" (click)="backToLogin()">
            Vai al login
        </button>
    </div>
</div>
